import { render, staticRenderFns } from "./DrawingCanvas.vue?vue&type=template&id=5d8db70e&scoped=true&"
import script from "./DrawingCanvas.vue?vue&type=script&lang=ts&"
export * from "./DrawingCanvas.vue?vue&type=script&lang=ts&"
import style0 from "./DrawingCanvas.vue?vue&type=style&index=0&id=5d8db70e&scoped=true&lang=css&"
import style1 from "./DrawingCanvas.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8db70e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
